import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'

import PropTypes from 'prop-types'
import moment from 'moment'
import get from 'lodash/get'
import SendModal from './SendModal'
import gql from 'graphql-tag'
import { client } from './../../index'
import { NotificationManager } from 'react-notifications'
import { getSmsBody, getMailBody } from '../../constants'

import { mainConfig } from './../../config'


class TripCard extends Component {
  static propTypes = {
    data: PropTypes.object,
    index: PropTypes.number,
    onPreviewClick: PropTypes.func,
    onEditClick: PropTypes.func,
    onCopyClick: PropTypes.func,
    onDeleteClick: PropTypes.func,
    showAsTrip: PropTypes.bool,
    t: PropTypes.func
  }

  state = {
    modalIsShown: false,
    smsChecked: false,
    emailChecked: false,
    lastFileTimestamp: null,
    generatingPdf: false
  }

  showModal = () => {
    this.setState({ modalIsShown: !this.state.modalIsShown })
  }

  fetchPdfTimestamp() {
    let url = `${mainConfig.planS3}${this.props.data.tripDetails.id}.pdf`
    fetch(url, {
      method: 'HEAD',
      headers:{'content-type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS, HEAD,'},
      mode: 'no-cors'
    })
    .then(response => {
      if (response.status === 200) {
        let ts = response.headers.get('last-modified')
        if (ts !== this.state.lastFileTimestamp) {
          this.setState({
              lastFileTimestamp: response.headers.get('last-modified'),
              generatingPdf: false
            })
        }
      }
    })
  }

  componentDidMount() {
    this.fetchPdfTimestamp()
  }

  renderOrderName() {
    let result = ''

    if (this.props.data.orderingUser) {
     
            let profile = this.props.data.orderingUser.userProfile[0]
             if(profile != null)
             {
                result += profile.firstName + ' ' + profile.lastName

                if (profile.email) {
                  result += ', ' + profile.email
                }
                if (profile.phone) {
                  result += ', ' + profile.phone
                }
            }
  }

    return result
  }

  sendSms = () => {
    client
      .mutate({
        mutation: gql`
          mutation send($to: String!, $from: String!, $body: String!) {
            sendSms(to: $to, from: $from, body: $body) {
              sid
            }
          }
        `,
        variables: {
          to: get(this.props.data, 'orderingUser.userProfile.phone', ''),
          from: '+1 833-818-2020',
          body: getSmsBody(this.props.data.id)
        }
      })
      .then(() => NotificationManager.success('Invite SMS sended', 'Success', 5000))
      .catch(err => NotificationManager.error('Cant send message', 'Error', 5000))
  }

  sendMail = () => {
    client
      .mutate({
        mutation: gql`
          mutation sendMail($to: String!, $tripName: String!, $html: String!) {
            sendMail(to: $to, tripName: $tripName, html: $html) {
              sum
            }
          }
        `,
        variables: {
          to: get(this.props.data, 'orderingUser.userProfile.email', ''),
          tripName: this.props.data.tripDetails.title,
          html: getMailBody(this.props.data.id)
        }
      })
      .then(() => NotificationManager.success('Invite mail sended', 'Success', 5000))
      .catch(err => NotificationManager.error('Cant send mail', 'Error', 5000))
  }

  sendInvites = () => {
    if (this.state.smsChecked) {
      this.sendSms()
    }
    if (this.state.emailChecked) {
      this.sendMail()
    }
    this.showModal()
  }

  generatePdf() {
    console.log('generatePdf', this.props);
    if (!this.state.generatingPdf) {
      this.setState({generatingPdf: true},
        (state, props) => {
          let url = `${mainConfig.pdfGateway}${this.props.data.id}`
          fetch(url, {
            method: 'GET',
            headers:{'content-type': 'application/json',
                      'Access-Control-Allow-Origin': '*',
                      'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS'},
            mode: 'no-cors'
          })
          let timer = setInterval(() => {
            this.fetchPdfTimestamp()
            if (!this.state.generatingPdf) {
              clearInterval(timer)
            }
          }, 5000)              
        }
      )
    }
  }

  renderPdfData() {
    console.log('renderPdfData', this.props);
    let url = `${mainConfig.planS3}${this.props.data.id}.pdf`
    console.log('url', url);
    let url2 = `${mainConfig.pdfGateway}${this.props.data.id}`
    console.log('url2', url2);
    if (this.state.generatingPdf) {
      return this.props.t('generating_pdf')
    }
    else if (this.state.lastFileTimestamp) {
      let date = new Date(this.state.lastFileTimestamp)
      let formattedDate = moment(date).format('MMM DD YYYY, HH:mm')
      let pdfTitle = this.props.t('pdf_from')
      return <a href={url} target='_blank'>{pdfTitle}: {formattedDate}</a>
    }
    else {
      return this.props.t('get_pdf')
    }
  }

  renderDates() {
    let result = ''

    if (this.props.data.startDate) {
      result += moment(this.props.data.startDate).format('MMM D')
    }

    if (this.props.data.endDate) {
      result += ` - ${moment(this.props.data.endDate).format('MMM D')}`
    }

    return result
  }

  render() {
    return (
      <div className="trip">
        {console.log('this.props', this.props)}
        {this.state.modalIsShown && (
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 0 }} onClick={this.showModal} />
        )}
        <div className="trip__info__buttons__mobile">
          <button className="trip__info__button"
                onClick={e => {
                  e.stopPropagation()

                  this.props.onPreviewClick(this.props.data.id)
                }}
          >{this.props.t('preview')}</button>
          {!this.props.showAsTrip && (
          <button className="trip__info__button trip__info__button__send">{this.props.t('send')}</button>
          )}
        </div>
        <div
          className="trip__img"
          style={{
            backgroundImage: `url(${get(this.props.data, 'tripDetails.coverPhoto.s3Url', 'http://via.placeholder.com/300x200')})`
          }}
        />
        <div className="trip__info">
          <div className="trip__info__buttons">
            <div style={{ position: 'relative' }}>
              <button
                className="trip__info__button"
                onClick={e => {
                  e.stopPropagation()

                  this.props.onPreviewClick(this.props.data.id)
                }}
              >
                {this.props.t('preview')}
              </button>
              {!this.props.showAsTrip && (
              <button className="trip__info__button trip__info__button__send" onClick={this.showModal}>
                {this.props.t('send')}
              </button>
              )}
              {this.state.modalIsShown && (
                <SendModal
                  index={this.props.index}
                  email={this.state.emailChecked}
                  sms={this.state.smsChecked}
                  hideModal={this.showModal}
                  handleSubmit={this.sendInvites}
                  handleSmsClick={() => this.setState({ smsChecked: !this.state.smsChecked })}
                  handleEmailClick={() =>
                    this.setState({
                      emailChecked: !this.state.emailChecked
                    })
                  }
                />
              )}
            </div>
          </div>
          <div className="trip__info__main">
            <div className="trip__info__main__date">{this.renderDates()}</div>
            <div className="trip__info__main__title">{get(this.props.data, 'tripDetails.title', '')}</div>
            {this.props.showAsTrip && (
            <div className="trip__info__main__order_clickable"></div>)
            }
            {!this.props.showAsTrip && (
            <div className="trip__info__main__order_clickable" 
              onClick={e => {
                e.stopPropagation()
                this.props.onEditUserDetails(this.props.data.id)}}>
                {this.renderOrderName()}</div>)
            }
            <div className="trip__info__main__order_clickable">{this.renderPdfData()}</div>
          </div>
          {!this.props.showAsTrip && (
          <div className="trip__bottom">
            <button
              className="trip__bottom__button trip__bottom__button__edit"
              onClick={e => {
                e.stopPropagation()

                this.props.onEditClick(this.props.data.id)
              }}
            >
              <i className="icon-edit" />
            </button>
            <button
              className="trip__bottom__button"
              onClick={e => {
                e.stopPropagation()

                this.generatePdf()
              }}
            >
              <i className="icon-arrow-down" />
            </button>
            <button
              className="trip__bottom__button"
              onClick={e => {
                e.stopPropagation()

                this.props.onCopyClick(this.props.index)
              }}
            >
              <i className="icon-file" />
            </button>
            <button
              className="trip__bottom__button"
              onClick={e => {
                e.stopPropagation()

                this.props.onDeleteClick(this.props.data.id)
              }}
            >
              <i className="icon-delete" />
            </button>
          </div>
          )}
        </div>
      </div>
    )
  }
}

const enhance = compose(translate('my_trips'))
export default enhance(TripCard)




// WEBPACK FOOTER //
// src/components/MyTrips/TripCard.js